/**
 * Constants for RaiseQuery page component
 */

export const DEFAULT_QUERY_TYPE_OPTIONS = [
  { value: 'General', label: 'General' },
  { value: 'Technical', label: 'Technical' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Operational', label: 'Operational' },
  { value: 'Other', label: 'Other' },
];

export const REGION_OPTIONS = [
  { value: 'NER', label: 'NER' },
  { value: 'NR', label: 'NR' },
  { value: 'WR', label: 'WR' },
  { value: 'SR', label: 'SR' },
  { value: 'ER', label: 'ER' },
  // { value: 'HO', label: 'HO' },
];

export const LIFECYCLE_STATUS_STYLES = {
  raised: { label: 'Open', color: '#4f9da6' },
  open: { label: 'Open', color: '#4f9da6' },
  submitted: { label: 'Submitted', color: '#1d4ed8' },
  pending: { label: 'Pending', color: '#f39c3d' },
  responded: { label: 'Responded', color: '#1e40af' },
  resolved: { label: 'Resolved', color: '#2e7d32' },
  escalated: { label: 'Escalated', color: '#d97706' },
  delegated: { label: 'Delegated', color: '#0ea5e9' },
  reopened: { label: 'Need Clarification', color: '#7c3aed' },
  additional_clarification: { label: 'Additional Clarification', color: '#f59e0b' },
  closed: { label: 'Closed', color: '#388e3c' },
};

export const REGION_COLOR_MAP = {
  'NER': '#16A34A', // Green
  'NR': '#3B82F6',  // Blue
  'WR': '#8B5CF6',  // Purple
  'SR': '#F59E0B',  // Amber
  'ER': '#0f172a',  // Dark
  // 'HO': '#DC2626',  // Red
};

/**
 * Get region color by code
 * @param {string} code - Region code
 * @returns {string} Color hex code
 */
export const getRegionColor = (code) => {
  return REGION_COLOR_MAP[code] || '#64748b';
};

export const STATUS_CARD_CONFIG = [
  { label: 'Raised', key: 'raised', color: '#16A34A', bgColor: '#dcfce7' },
  { label: 'Closed', key: 'closed', color: '#8B5CF6', bgColor: '#e9d5ff' },
  { label: 'Delegated', key: 'delegated', color: '#F59E0B', bgColor: '#fde68a' },
  { label: 'Escalated', key: 'escalated', color: '#DC2626', bgColor: '#fecaca' },
];
